import { render, staticRenderFns } from "./SlideTBM.vue?vue&type=template&id=411114e4&"
import script from "./SlideTBM.vue?vue&type=script&lang=js&"
export * from "./SlideTBM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports